var _rect, _path, _rect2, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconzip = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#757575",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.414 6H10C8.897 6 8 6.898 8 8V24C8 25.103 8.897 26 10 26H22C23.103 26 24 25.103 24 24V10.586L19.414 6ZM11 16H19V18H11V16ZM21 22H11V20H21V22ZM18 12V7L23 12H18Z",
    fill: "#757575"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 12,
    height: 8,
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2902 22V21.5437L14.1048 18.9975H12.2866V18.3636H15.0707V18.82L13.2543 21.3661H15.0743V22H12.2902ZM16.433 18.3636V22H15.6642V18.3636H16.433ZM17.0656 22V18.3636H18.5002C18.776 18.3636 19.011 18.4163 19.2051 18.5217C19.3993 18.6258 19.5472 18.7708 19.649 18.9567C19.752 19.1413 19.8035 19.3544 19.8035 19.5959C19.8035 19.8374 19.7514 20.0504 19.6472 20.2351C19.5431 20.4197 19.3921 20.5636 19.1945 20.6665C18.998 20.7695 18.76 20.821 18.4807 20.821H17.5663V20.2049H18.3564C18.5044 20.2049 18.6263 20.1795 18.7222 20.1286C18.8192 20.0765 18.8914 20.0049 18.9388 19.9137C18.9873 19.8214 19.0116 19.7154 19.0116 19.5959C19.0116 19.4751 18.9873 19.3698 18.9388 19.2798C18.8914 19.1887 18.8192 19.1183 18.7222 19.0685C18.6251 19.0176 18.502 18.9922 18.3528 18.9922H17.8344V22H17.0656Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconzip, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconzip.001067f7.svg";
export { ForwardRef as ReactComponent };